import { type PayloadAction, createSlice } from "@reduxjs/toolkit";
import { ReducerEntityPrefixTypes, ReducerNamespaceTypes } from "enums";
import { getPrefix } from "features/Application/slices/models";
import { type EnrollmentCompaniesState } from "../types";
import { fetchGroupEnrollmentCompanyNames } from "../thunks/enrollmentCompaniesThunk";

const initialState: EnrollmentCompaniesState = {
  isLoading: false,
  items: [],
};

const groupEnrollmentCompaniesSlice = createSlice({
  name: getPrefix({
    namespace: ReducerNamespaceTypes.People,
    entity: ReducerEntityPrefixTypes.Groups,
    name: "enrollmentCompanies",
  }),
  initialState,
  reducers: {
    fetchBegin(state) {
      state.isLoading = true;
    },
    fetchSuccess(state: EnrollmentCompaniesState, action: PayloadAction<string[]>) {
      state.items = action.payload;
      state.isLoading = false;
    },
    fetchFailure(state: EnrollmentCompaniesState, action: PayloadAction<Error>) {
      state.isLoading = false;
      state.error = action.payload;
    },
    resetEnrollmentCompanies() {
      return { ...initialState };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchGroupEnrollmentCompanyNames.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchGroupEnrollmentCompanyNames.fulfilled, (state, action) => {
        if (state.isLoading) {
          state.isLoading = false;
          state.items = action.payload;
        }
      })
      .addCase(fetchGroupEnrollmentCompanyNames.rejected, (state, action) => {
        if (state.isLoading) {
          state.isLoading = false;
          state.error = action.error as Error;
        }
      });
  },
});

export const { fetchBegin, fetchSuccess, resetEnrollmentCompanies, fetchFailure } =
  groupEnrollmentCompaniesSlice.actions;

export const enrollmentCompaniesReducer = groupEnrollmentCompaniesSlice.reducer;
